export default __webpack_public_path__ + "static/ana-oprita-cb3488798616dbab3142af114da1d415.svg";